import { Dispatch} from "react";
import axios from 'axios';
import { IADPActions } from "../state/Actions";
import {actions } from "../state";
import { Content } from "../types/Content";
import { environment } from "../util/util";
let en:Content| undefined = undefined;
let es:Content| undefined= undefined;
const logPrefix = "[ADPClient][ContentServiceHook]"
export function useContentService(dispatch:Dispatch<IADPActions>) {
   function  fetchContent(locale: "en" | "es",init: boolean = false) {
    return new Promise((resolve):void => {
      // do some async task
      console.log(logPrefix,`fetching ${locale.toUpperCase()} content`);
      if(locale === "en" && en) {
        dispatch(actions.createSetContentAction(en));
        resolve(en);
      } 
      else if(locale === "es" && es) {
        dispatch(actions.createSetContentAction(es)); 
        resolve(es);
      }
     axios.get(`${environment.resovleAppDomain()}/locale/${locale}.json`)
    .then(function (response) {
      console.log(logPrefix,locale.toUpperCase(),"content fetch status", response.status);
      if(locale === "en") en = response.data;
      if(locale === "es") es = response.data;
      //set mode selection view on initial load
      if(init) {
        //prefetch content
        dispatch(actions.createSetContentAction(response.data));
        fetchContent(locale === "en" ? "es" :"en");
        resolve(response.data);
      };
    })
    .catch(function (error) {
      // handle error
      console.log(logPrefix,"error fetching content",error);
      dispatch(actions.createSetViewAction("LoadingErrroView"));
      resolve(false);
    })
   });
  
  }
 
  return {fetchContent}
}
